// Automatische Bearbeitungsfrist für KI-erstellte Tickets (Spec: „Frist: z. B. 2 Werktage").
// Rein rechnerisch (testbar); angewandt in analyseZuTicketVorlage — manuell erstellte
// Tickets behalten ihre frei wählbare Frist.

/** Werktage pro Priorität (Ticket-Vokabular niedrig/mittel/hoch/kritisch). */
export const FRIST_WERKTAGE: Record<string, number> = {
  kritisch: 1,
  hoch: 2,
  mittel: 3,
  niedrig: 5,
};

/** Addiert n Werktage (Mo–Fr); Samstag/Sonntag werden übersprungen. */
export function addiereWerktage(start: Date, tage: number): Date {
  const d = new Date(start);
  let rest = tage;
  while (rest > 0) {
    d.setDate(d.getDate() + 1);
    const tag = d.getDay();
    if (tag !== 0 && tag !== 6) rest--;
  }
  return d;
}

/** ISO-Datum (yyyy-mm-dd) der Frist für eine Priorität, null bei unbekannter Stufe. */
export function fristFuerPrioritaet(prioritaet: string, ab: Date = new Date()): string | null {
  const tage = FRIST_WERKTAGE[prioritaet];
  if (!tage) return null;
  return addiereWerktage(ab, tage).toISOString().slice(0, 10);
}
